module.exports = __webpack_public_path__ + "assets/img/00176.8477b2e5.png";